import { gql } from 'apollo-angular'

const EDITOR_DETAILS = gql`
  fragment EditorDetails on AuthorInEditorialBoard {
    id
    gender
    name
    pre_title
    initials
    post_title
    first_name
    middle_name
    last_name
    pdf_author_name
    colophon_name
    firm_page
    social_link
    function
    about
  }
`

export const GET_EDITORS = gql`
  query {
    editors {
      redaction {
        ...EditorDetails
      }
      editorialSecretary {
        ...EditorDetails
      }
      chiefEditor {
        ...EditorDetails
      }
      permanentEmployees {
        ...EditorDetails
      }
      users {
        ...EditorDetails
      }
    }
  }
  ${EDITOR_DETAILS}
`
